import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/landing.css';

const Home = () => {
  return (
    <div className="landing">
      {/* Hero */}
      <section className="hero">
        <div className="hero__bg" />
        <div className="hero__content">
          <span className="hero__eyebrow">Media Monitoring & Intelligence</span>
          <h1 className="hero__title">
            Helping you make <em>informed</em> decisions.
          </h1>
          <p className="hero__subtitle">
            Track, analyse, and act on media coverage across print, broadcast, and digital — all from one powerful platform.
          </p>
          <div className="hero__actions">
            <Link to="/login" className="btn btn--primary btn--lg">
              Get Started
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </Link>
            <Link to="/contact" className="btn btn--outline-light btn--lg">
              Contact Us
            </Link>
          </div>
        </div>
        {/* Decorative elements */}
        <div className="hero__decoration hero__decoration--1" />
        <div className="hero__decoration hero__decoration--2" />
      </section>

      {/* Features */}
      <section className="features">
        <div className="features__inner">
          <div className="features__header">
            <span className="features__label">How It Works</span>
            <h2 className="features__title">Intelligence at Every Step</h2>
          </div>

          <div className="features__grid">
            <article className="feature-card" style={{ '--delay': '0ms' }}>
              <div className="feature-card__icon">
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none"><path d="M4 8h20M4 14h20M4 20h12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
              </div>
              <h3 className="feature-card__title">What We Do</h3>
              <p className="feature-card__text">
                We track and analyse mentions of brands, clients, and industry topics across print, audio, social, video, and online media — including news websites and digital mentions.
              </p>
            </article>

            <article className="feature-card" style={{ '--delay': '100ms' }}>
              <div className="feature-card__icon">
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none"><path d="M14 4v20M4 14h20" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><circle cx="14" cy="14" r="10" stroke="currentColor" strokeWidth="1.5"/></svg>
              </div>
              <h3 className="feature-card__title">How It Works</h3>
              <p className="feature-card__text">
                We identify key publications — daily, weekly, monthly — gather your keywords and phrases, upload and process publications using cutting-edge extraction methods, then generate actionable reports.
              </p>
            </article>

            <article className="feature-card" style={{ '--delay': '200ms' }}>
              <div className="feature-card__icon">
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none"><path d="M4 20l6-6 4 4 10-10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M18 8h6v6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </div>
              <h3 className="feature-card__title">Data Analytics</h3>
              <p className="feature-card__text">
                Comprehensive media monitoring across print, broadcast, online, and social channels — helping businesses and organisations make informed, data-driven decisions about their strategy.
              </p>
            </article>
          </div>
        </div>
      </section>

      {/* Stats band */}
      <section className="stats-band">
        <div className="stats-band__inner">
          <div className="stat">
            <span className="stat__number">500+</span>
            <span className="stat__label">Publications Tracked</span>
          </div>
          <div className="stat">
            <span className="stat__number">24/7</span>
            <span className="stat__label">Monitoring Active</span>
          </div>
          <div className="stat">
            <span className="stat__number">98%</span>
            <span className="stat__label">Accuracy Rate</span>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
